// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__XMd-Y","label":"Category_label__2UDza","content":"Category_content__3jTwk","header":"Category_header__E0r33","location":"Category_location__2XnhC"};